import React, { useState, useEffect } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import Select from "react-select";
import { getServiceCenterCashDetailsApi } from "../../services/ServiceApi";
import {
  createCashFlowApi,
  updateCashFlowApi,
} from "../../services/CashFlowService";
import {
  CashFlowOption,
  formatToIndianNumber,
  useIsMobile,
} from "../../utilities";
import { useSelector } from "react-redux";
import { getSearchEmployeeWithUser } from "../../services/SearchService";
const AddCashFlowModal = ({ visible, onClose, onAfterSubmit, data = null }) => {
  const isMobile = useIsMobile();
  const user = useSelector((state) => state?.auth?.user);
  const [toatlCash, setTotalCash] = useState(0);
  const [pettyCash, setPettyCash] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedCashFlowCategory, setSelectedCashFlowCategory] =
    useState(null);
  const [sourceOption, setSourceOption] = useState([]);
  const [selectedSource, setSelectedSource] = useState(null);
  const [pettyCashsourceOption, setPettycashSourceOption] = useState([]);
  const [selectedPettyCashSource, setSelectedPettyCashSource] = useState(null);
  const [userLoading, setUserLoading] = useState(false);
  const [userOption, setUserOption] = useState([]);
  const [selectedUser, setSelecetdUser] = useState(null);
  const [form, setForm] = useState({
    date: new Date().toISOString().split("T")[0],
    amount: "",
    category: "",
    description: "",
    advance_payment_source: "",
    pettyCash_payment_source: "",
    reference_id: "",
    user: "",
  });
  const [error, setError] = useState({});
  const getSource = (source) => {
    getServiceCenterCashDetailsApi(user?.service_center_id || "")
      .then((res) => {
        const apiData = res?.data?.results;
        setTotalCash(apiData?.total_cash || 0);
        setPettyCash(apiData?.total_petty_cash || 0);
        const options = [
          {
            label: `Total Cash (Available Amount: ${apiData?.total_cash || 0})`,
            value: "CASH",
          },
          {
            label: `Petty Cash (Available Amount: ${
              apiData?.total_petty_cash || 0
            })`,
            value: "PETTY_CASH",
          },
          {
            label: "Total and Petty Cash",
            value: "BOTH",
          },
          {
            label: "UPI",
            value: "UPI_BUSINESS",
          },
        ];
        const pettySourceOption = [
          {
            label: `Total Cash (Available Amount: ${apiData?.total_cash || 0})`,
            value: "CASH",
          },
          {
            label: "UPI",
            value: "UPI_BUSINESS",
          },
        ];
        setSourceOption(options || []);
        setPettycashSourceOption(pettySourceOption || []);
        if (data?.category == "Advance") {
          setSelectedSource(
            options?.find((item) => item?.value == source) || null
          );
        } else {
          setSelectedSource(null);
        }
        if (data?.category == "Petty Cash") {
          setSelectedPettyCashSource(
            pettySourceOption?.find((item) => item?.value == source) || null
          );
        } else {
          setSelectedPettyCashSource(null);
        }
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };
  useEffect(() => {
    if (visible) {
      getSource(data?.payment_mode);
      handleReset();
    }
  }, [visible]);

  const handleReset = () => {
    if (data) {
      setForm({
        ...form,
        date: data?.date || new Date().toISOString().split("T")[0],
        amount: Number(data?.amount || "") || "",
        description: data?.description || "",
        reference_id: data?.reference_id || "",
      });
      setSelectedCashFlowCategory(
        CashFlowOption.find((item) => item?.value == data?.category) || null
      );
      getUser(data?.user);
    } else {
      setForm({
        date: new Date().toISOString().split("T")[0],
        amount: "",
        category: "",
        description: "",
        advance_payment_source: "",
        pettyCash_payment_source: "",
        reference_id: "",
        user: "",
      });
      setSelectedCashFlowCategory(null);
      setSelectedSource(null);
      setSelectedPettyCashSource(null);
      setSelecetdUser(null);
    }

    setError({});
  };
  const getUser = (id) => {
    setUserLoading(true);
    getSearchEmployeeWithUser()
      .then((res) => {
        const employee = res?.data?.employees || [];
        const user = res?.data?.users || [];
        const option = [...employee, ...user];
        setUserOption(option);
        setSelecetdUser(option.find((item) => item?.value == id) || null);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setUserLoading(false);
      });
  };
  useEffect(() => {
    setForm({
      ...form,
      category: selectedCashFlowCategory?.value || "",
      advance_payment_source: selectedSource?.value || "",
      pettyCash_payment_source: selectedPettyCashSource?.value || "",
      user: selectedUser?.value || "",
    });
    if (error?.category && selectedCashFlowCategory?.value) {
      setError({ ...error, category: "" });
    }
    if (error?.advance_payment_source && selectedSource?.value) {
      setError({ ...error, advance_payment_source: "" });
    }
    if (error?.pettyCash_payment_source && selectedPettyCashSource?.value) {
      setError({ ...error, pettyCash_payment_source: "" });
    }
    if (error?.user && selectedUser?.value) {
      setError({ ...error, user: "" });
    }
  }, [
    selectedCashFlowCategory,
    selectedSource,
    selectedPettyCashSource,
    selectedUser,
  ]);
  useEffect(() => {
    if (selectedCashFlowCategory?.value == "Advance") {
      getUser(data?.user);
    }
    setSelectedSource(null);
    setSelectedPettyCashSource(null);
  }, [selectedCashFlowCategory]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({ ...prev, [name]: value }));
    if (
      name == "amount" &&
      (form?.category == "Cash Handover" || form?.category == "Bank Deposit")
    ) {
      if (value && Number(value) > Number(toatlCash) + Number(pettyCash)) {
        setError({
          ...error,
          amount: `Amount should less than ${
            Number(toatlCash) + Number(pettyCash)
          }`,
        });
      } else {
        setError({ ...error, amount: "" });
      }
    } else {
      if (error?.[name]) {
        setError((prev) => ({ ...prev, [name]: "" }));
      }
    }
  };

  const handleSubmit = () => {
    let error = {};

    if (!form.category) error.category = "Category is required";
    if (!form.date) error.date = "date is required";
    if (!form.amount) {
      error.amount = "Amount is required";
    } else if (
      (form.category === "Cash Handover" || form.category === "Bank Deposit") &&
      Number(form.amount) > Number(toatlCash) + Number(pettyCash)
    ) {
      error.amount = `Amount should be less than ${
        Number(toatlCash) + Number(pettyCash)
      }`;
    }
    if (form?.category === "Advance") {
      if (!form?.advance_payment_source) {
        error.advance_payment_source = "Required Field";
      }
      if (!form?.user) {
        error.user = "Required Field";
      }
    }
    if (form?.category === "Petty Cash") {
      if (!form?.pettyCash_payment_source) {
        error.pettyCash_payment_source = "Required Field";
      }
    }
    if (
      form?.advance_payment_source == "UPI_BUSINESS" ||
      form?.pettyCash_payment_source == "UPI_BUSINESS"
    ) {
      if (!form?.reference_id) {
        error.reference_id = "Required Field";
      }
    }
    setError(error);

    if (Object.keys(error).length === 0) {
      const {
        pettyCash_payment_source,
        advance_payment_source,
        reference_id,
        user,
        ...rest
      } = form;

      let payment_mode = null;
      if (form?.category === "Advance") {
        payment_mode = advance_payment_source;
      } else if (form?.category === "Petty Cash") {
        payment_mode = pettyCash_payment_source;
      }
      let payload = {
        ...rest,
        ...(payment_mode && { payment_mode }),
        ...(payment_mode === "UPI_BUSINESS" && { reference_id }),
        ...(form?.category === "Advance" && { user }),
      };
      if (data) {
        updateCashFlow(payload);
      } else {
        addCashFlow(payload);
      }
    }
  };

  const addCashFlow = (payload) => {
    setLoading(true);
    createCashFlowApi(payload)
      .then(() => {
        toast.success("CashFlow created successfully");
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => setLoading(false));
  };

  const updateCashFlow = (payload) => {
    setLoading(true);
    updateCashFlowApi(payload)
      .then(() => {
        toast.success("CashFlow update successfully");
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => setLoading(false));
  };

  return (
    <Modal show={visible} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {data ? "Update Cash Transaction" : "Cash Transaction"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row p-1 g-2">
          <div className="col-md-6">
            <label className="form-label text-dark">Cashflow category</label>
            <Select
              classNamePrefix="select"
              className="react-select"
              placeholder="Select category"
              options={CashFlowOption}
              value={selectedCashFlowCategory}
              onChange={setSelectedCashFlowCategory}
            />
            {error?.category && (
              <small className="text-danger">{error?.category}</small>
            )}
          </div>
          <div className="col-md-6">
            <label className="form-label text-dark">Amount</label>
            {(form?.category == "Cash Handover" ||
              form?.category == "Bank Deposit") && (
              <span
                className="text-danger fw-medium ms-1"
                style={{ fontSize: "0.8rem" }}
              >
                (
                {`${isMobile ? "Cash:" : ""}₹${formatToIndianNumber(
                  toatlCash
                )} + Petty Cash:₹${formatToIndianNumber(pettyCash)}`}
                )
              </span>
            )}
            <input
              type="text"
              name="amount"
              className={`form-control ${error?.amount ? "is-invalid" : ""}`}
              value={form.amount}
              placeholder="e.g. ₹4000"
              onChange={(e) => {
                if (/^\d*$/.test(e.target.value)) {
                  handleInputChange(e);
                }
              }}
            />
            {error?.amount && (
              <small className="text-danger">{error.amount}</small>
            )}
          </div>
          {form?.category === "Advance" && (
            <>
              <div className="col-md-6">
                <label className="form-label text-dark">User</label>
                <Select
                  classNamePrefix="select"
                  className="react-select"
                  placeholder="Select User"
                  options={userOption}
                  value={selectedUser}
                  onChange={setSelecetdUser}
                  isLoading={userLoading}
                />
                {error?.user && (
                  <small className="text-danger">{error?.user}</small>
                )}
              </div>
              <div className="col-md-6">
                <label className="form-label text-dark">Payment Source</label>
                <Select
                  classNamePrefix="select"
                  className="react-select"
                  placeholder="Select Source"
                  options={sourceOption}
                  value={selectedSource}
                  onChange={setSelectedSource}
                />
                {error?.advance_payment_source && (
                  <small className="text-danger">
                    {error?.advance_payment_source}
                  </small>
                )}
              </div>
            </>
          )}
          {form?.category === "Petty Cash" && (
            <div className="col-12">
              <label className="form-label text-dark">Payment Source</label>
              <Select
                classNamePrefix="select"
                className="react-select"
                placeholder="Select sub-category"
                options={pettyCashsourceOption}
                value={selectedPettyCashSource}
                onChange={setSelectedPettyCashSource}
              />
              {error?.pettyCash_payment_source && (
                <small className="text-danger">
                  {error?.pettyCash_payment_source}
                </small>
              )}
            </div>
          )}
          {(form?.advance_payment_source == "UPI_BUSINESS" ||
            form?.pettyCash_payment_source == "UPI_BUSINESS") && (
            <div className="col-12">
              <label className="form-label text-dark">Reference ID</label>
              <input
                type="text"
                name="reference_id"
                placeholder="REF123"
                className={`form-control ${
                  error?.reference_id ? "is-invalid" : ""
                }`}
                value={form.reference_id}
                onChange={handleInputChange}
              />
              {error?.reference_id && (
                <small className="text-danger">{error.reference_id}</small>
              )}
            </div>
          )}

          <div className="col-12">
            <label className="form-label text-dark">Date</label>
            <input
              type="date"
              name="date"
              className={`form-control ${error?.date ? "is-invalid" : ""}`}
              value={form.date}
              onChange={handleInputChange}
              max={new Date().toISOString().split("T")[0]}
            />
            {error?.date && <small className="text-danger">{error.date}</small>}
          </div>

          <div className="col-12">
            <label className="form-label text-dark">Description</label>
            <textarea
              name="description"
              className="form-control"
              value={form.description}
              onChange={handleInputChange}
              rows={2}
              placeholder="Enter description"
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end gap-2 w-100">
          <button
            className="btn btn-outline-dark"
            disabled={loading}
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading && <Spinner animation="border" size="sm" />}
            {data ? "Update" : "Submit"}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AddCashFlowModal;
